<template>
  <div id="quick_nav">
    <div class="tit">
      <img src="../../assets/images/nav/QUICK.png" alt="" />
      <img src="../../assets/images/nav/MENU.png" alt="" />
    </div>
    <ul>
      <li>
        <router-link :to="{ name: 'orders' }"
          ><img
            src="../../assets/images/nav/icon_hat.png"
            alt="마이페이지"
          /><span>마이페이지</span></router-link
        >
      </li>
      <li>
        <router-link :to="{ name: 'library_default' }">
          <img src="../../assets/images/nav/icon_book.png" alt="내서재" /><span
            >내서재</span
          >
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'cart' }">
          <img
            src="../../assets/images/nav/icon_cart.png"
            alt="장바구니"
          /><span>장바구니</span></router-link
        >
      </li>
      <li>
        <a :href="'https://pf.kakao.com/_wxkIdb'" target="_blank">
          <img
            src="../../assets/images/nav/icon_kakao.png"
            alt="1:1문의"
          /><span>1:1 문의</span></a
        >
      </li>
    </ul>
    <div class="btn_w">
      <button @click="scrollTop">
        <img src="../../assets/images/nav/icon_top.png" alt="상단이동" />
      </button>
      <div><img src="../../assets/images/nav/TOP.png" alt="" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickNavigator',
  data() {
    return {}
  },
  computed: {},

  methods: {
    scrollTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
#quick_nav {
  display: none;
}
@media screen and (min-width: 1439px) {
  #quick_nav {
    //   font-size: clamp(12px, 2.25vw, 48px);
    //   width: 3.75em;
    display: block;
    position: fixed;
    // right: clamp(24px, 3vw, 80px);
    right: calc(50vw - 725px);
    bottom: 5%;
    // transform: translateY(-50%);
    z-index: 99999;
    width: 98px;
    background-color: #36c2b5;
    padding: 12px 8px;
    border-radius: 8px;
    .tit {
      text-align: center;
      line-height: 0;

      > img {
        width: 75%;
        &:last-child {
          margin: -6px 0px 4px;
        }
      }
    }
    ul {
      background-color: #ffffff;
      border-radius: 8px;
      padding: 12px 4px;
      li {
        padding: 4px 0px 6px;
        margin-bottom: 6px;
        border-bottom: 1px solid #c2c2c2;
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          margin-bottom: 0;
          padding-bottom: 0;
          border: none;
        }
        > a {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 6px;
        }
        img {
          width: 70%;
          max-width: 46px;
        }
        font-size: 0.8125rem;
        font-weight: 600;
        color: #666666;
      }
      margin-bottom: 0.25em;
    }
    .btn_w {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding-top: 12px;
      button {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        img {
          width: 100%;
        }

        //   background-color: #ffffff;
      }
      > div {
        // height: ;
        width: 100%;
        text-align: center;
        > img {
          width: 36px;
        }
      }
    }
  }
}
</style>
